/**
 *
 * PortalTemplate
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 19-Oct-2022
 */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import PortalAppNavigation from 'Components/PortalAppNavigation';
import PortalHeader from 'Components/PortalHeader';
import PortalFooter from 'Components/PortalFooter';
import flowPopupMap from 'Utility/flowPopupMap';
import { routes } from '../PortalAppNavigation/utils/routeNames';
import style from './PortalTemplate.scss';

const isRouteAuthorized = (currentPath, permittedRoutes) => {
	const normalizedPath = currentPath.split('/')[1];

	const editedRoutes = [...routes, { routeName: 'Account', route: 'account' }];
	const isPermittedRoute = editedRoutes.some(
		(route) => route.route === normalizedPath && permittedRoutes.includes(route.routeName)
	);

	return isPermittedRoute;
};

const PortalTemplate = (props) => {
	const location = useLocation();
	const navigate = useNavigate();

	const currentPath = location.pathname;

	// Verifica se la route corrente è autorizzata
	if (props.logged && !isRouteAuthorized(currentPath, props.permittedRoutes) && currentPath !== '/') {
		// Reindirizza alla home se non autorizzato
		navigate('/');
		return null; // Evita il rendering della pagina non autorizzata
	}

	let flowPopup = '';
	if (props.flowPopupId) {
		flowPopup = flowPopupMap[props.flowPopupId];
	}

	return (
		<Grid className={`${style.template} ${props.className}`}>
			{props.withNavigation ? (
				<PortalAppNavigation logged={props.logged} permittedRoutes={props.permittedRoutes} />
			) : (
				<PortalHeader
					title={props.pageTitle}
					backCopy={props.goBackLabel}
					backOnClick={props.customGoBackOnClick}
					route={props.goToRoute}
					hasLightBackground={props.hasLightBackground}
					hasLogo={props.hasLogo}
				/>
			)}
			{props.children}
			{props.logged && props.showFooter ? <PortalFooter /> : null}
			{flowPopup}
		</Grid>
	);
};

PortalTemplate.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
	className: PropTypes.string,
	pageTitle: PropTypes.string,
	goBackLabel: PropTypes.string,
	customGoBackOnClick: PropTypes.func,
	withNavigation: PropTypes.bool,
	flowPopupId: PropTypes.string,
	showFooter: PropTypes.bool,
	logged: PropTypes.bool,
	goToRoute: PropTypes.string,
	hasLightBackground: PropTypes.bool,
	hasLogo: PropTypes.bool,
	permittedRoutes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

PortalTemplate.defaultProps = {
	className: '',
	pageTitle: '',
	withNavigation: false,
	flowPopupId: '',
	showFooter: true,
	logged: false,
	goToRoute: '',
	hasLightBackground: false,
	hasLogo: false,
	permittedRoutes: ['Home'],
};

export default PortalTemplate;
